<ng-template #mergeFieldHistory let-entry>
  <div class="merge-history" [class.own-history]="entry.isCreator" [class.expanded]="!entry.historyHasMore || isMergeHistoryExpanded(entry)">
    <div class="merge-history-title" *ngIf="!entry.isCreator"><mat-icon aria-hidden="true">edit</mat-icon><span><strong>{{ entry.sender }}</strong> {{ 'negotiate_contract.chat.fields_updated' | translate }}</span></div>
    <div *ngFor="let field of entry.mergeFields | slice:0:(isMergeHistoryExpanded(entry) ? entry.mergeFields.length : 10); let last = last" class="merge-history-field">
      <span class="merge-history-label" [title]="field.fieldName">{{ field.fieldName }}</span>
      <div class="merge-history-values">
        <span *ngIf="field.oldValue !== ''" class="merge-history-value" [title]="field.oldValue">{{ field.oldValue }}</span>
        <span *ngIf="field.oldValue !== ''" class="merge-history-arrow" [attr.aria-label]="'negotiate_contract.chat.changed_to' | translate">→</span>
        <span class="merge-history-value" [title]="field.newValue">{{ field.newValue }}</span>
        <button *ngIf="last && entry.historyHasMore && !isMergeHistoryExpanded(entry)" type="button" class="merge-history-more" aria-expanded="false" (click)="$event.stopPropagation(); toggleMergeHistory(entry)">
          <span *ngIf="entry.mergeFields.length > 10">… </span>{{ 'negotiate_contract.chat.show_more' | translate }}
        </button>
      </div>
    </div>
    <button *ngIf="entry.historyHasMore && isMergeHistoryExpanded(entry)" type="button" class="merge-history-more merge-history-collapse" aria-expanded="true" (click)="$event.stopPropagation(); toggleMergeHistory(entry)">
      {{ 'negotiate_contract.chat.show_less' | translate }}
    </button>
    <div *ngIf="entry.historyInvalid">{{ 'negotiate_contract.chat.history_unavailable' | translate }}</div>
  </div>
</ng-template>

<div id="frm_add_or_edit" style="overflow: hidden">
<div class="row">
  <!-- sidebar left - Thông tin tài liệu -->
  <div [hidden]="tabMode === 'hide'" class="col-lg-5 col-md-12 col-sm-12 pr-0">
    <div class="card" style="
        height: calc(91vh - 140px);
        overflow-y: auto;
        border-radius: 0px !important;
        padding-bottom: 50px;
        border: none;
      ">
      <!--        <app-panel-document (hasChange)="onPanelChange($event)"></app-panel-document>-->
      <!-- <div class="card" style="padding-bottom: 10px;"> -->
<!--        <mat-tab-group [(selectedIndex)]="currentTab"-->
<!--          (selectedTabChange)="currentTab === 1 ? openTabSign() : tabMode = 'info'">-->
<!--          <mat-tab  >-->
<!--            <ng-template mat-tab-label>-->
<!--              <span>{{'title.document_info' | translate}}</span>-->
<!--            </ng-template>-->
<!--          </mat-tab>-->
<!--          <mat-tab [disabled]="!isHaveUserSign">-->
<!--            <ng-template mat-tab-label>-->
<!--              <span>{{'title.settings_footnote' | translate}}</span>-->
<!--            </ng-template>-->
<!--          </mat-tab>-->
<!--        </mat-tab-group>-->
<!--        <div [hidden]="currentTab !== 0">-->
<!--          <app-general-form-info [check]="1" [maxSize]="maxSize"></app-general-form-info>-->
<!--          <app-record-party-sign (resetSignPosition)="resetSignPosition()" (changePosition)="changeDataApprove($event)" [check]="1"></app-record-party-sign>-->
<!--          <app-general-form-info [check]="2" [maxSize]="maxSize"></app-general-form-info>-->
<!--&lt;!&ndash;          <app-general-form-info [maxSize]="maxSize"></app-general-form-info>&ndash;&gt;-->
<!--&lt;!&ndash;          <app-record-party-sign (resetSignPosition)="resetSignPosition()" (changePosition)="changeDataApprove($event)"></app-record-party-sign>&ndash;&gt;-->
<!--        </div>-->
      <div [hidden]="currentTab !== 0">
        <app-general-form-info [maxSize]="maxSize"></app-general-form-info>
        <app-record-party-sign (resetSignPosition)="resetSignPosition()" (changePosition)="changeDataApprove($event)" (changeDataEnterprise)="changeDataEnterprise($event)"></app-record-party-sign>
      </div>

      
      <!-- user sign -->
      <div  style="overflow-y: auto">
        <div class="col-12 text-title">
          <mat-label>{{'title.resources_used' | translate}} {{generalFormInfoComponent.convertTitleResource()}}</mat-label>
        </div>
        <!-- Thương thảo hợp đồng -->
      <mat-expansion-panel class="mat-elevation-z0" expanded="true" *ngIf="isNegotiate && !flagCopy">
        <mat-expansion-panel-header>
          <mat-panel-title class="mat-panel-title">
            {{ "negotiate_contract.label" | translate }}
          </mat-panel-title>
        </mat-expansion-panel-header>
        <div class="chat-container">
    
          <!-- Danh sách tin nhắn -->
          <div class="message-list" #scrollContainer>
            <ng-container *ngIf="messages.length > 0; else noMessage" #messageItem>
              <div class="w-100 message-row d-flex" *ngFor="let msg of messages" [ngClass]="msg.isCreator ? 'justify-content-end' : 'justify-content-start'">
                <div class="message position-relative" [class.merge-history-message]="msg.type === 2" [id]="'message-id-' +msg.id" [ngClass]="msg.isCreator ? 'me': 'notme'">
                  <div class="sender fw-bold small mb-1" [hidden]="msg.isCreator">{{ msg.sender }}</div>
                  <div class="reply-message-1  mb-2" *ngIf="msg.parent">
                    <div class="reply-message-content" (click)="scrollToMessage(msg.parent)">
                      <div class="font-size-12">{{ msg.parent.isCreator ? ('negotiate_contract.chat.you' | translate) : msg.parent.sender}}</div>
                      <div class="bubble-reply" *ngIf="msg.parent.type !== 2">{{ msg.parent.content }}</div>
                      <div class="bubble-reply" *ngIf="msg.parent.type === 2">{{ msg.parent.historyInvalid ? ('negotiate_contract.chat.history_unavailable' | translate) : getNegotiateCopyText(msg.parent) }}</div>
                      <div *ngIf="msg.parent.attachments.length > 0" class="d-flex align-items-center message-file" style="margin: 0; padding: 0;">
                        <div style="width: 24px;">
                          <svg viewBox="0 0 36 36" class="x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq xfx01vb" fill="currentColor" height="24" width="24" style="--color: var(--primary-icon);"><path clip-rule="evenodd" d="M18 8c0-.6-.4-1-1-1h-6a2 2 0 00-2 2v18c0 1.1.9 2 2 2h14a2 2 0 002-2V17c0-.6-.4-1-1-1h-4a4 4 0 01-4-4V8zm-6 7c0-.6.4-1 1-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zm1 3.5a1 1 0 100 2h10a1 1 0 100-2H13zm0 4.5a1 1 0 100 2h10a1 1 0 100-2H13z" fill-rule="evenodd"></path><path d="M22 14h4a1 1 0 00.7-1.7l-5-5A1 1 0 0020 8v4c0 1.1.9 2 2 2z"></path></svg>
                        </div>
                        <div style="width: 100%; flex: 1;">
                          <div style="font-size: 14px;" class="file-name">{{ msg.parent.attachments[0].fileName }}</div>
                          <div style="font-size: 11px;">{{formatFileSize(msg.parent.attachments[0].fileSize)}} <span class="mx-2">&bull;</span> {{getTailFile(msg.parent.attachments[0].fileName)}}</div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="bubble" *ngIf="msg.type !== 2 && msg.content" [innerHTML]="msg.content | linkify"></div>
                  <ng-container *ngIf="msg.type === 2" [ngTemplateOutlet]="mergeFieldHistory" [ngTemplateOutletContext]="{ $implicit: msg }"></ng-container>
                  <div *ngIf="msg.attachments.length > 0">
                    <div *ngFor="let file of msg.attachments" class="d-flex align-items-center message-file" role="button" tabindex="0" (click)="downLoadFileNegotiate(file)">
                      <div style="width: 24px;">
                        <svg viewBox="0 0 36 36" class="x1lliihq x1tzjh5l x1k90msu x2h7rmj x1qfuztq xfx01vb" fill="currentColor" height="24" width="24" style="--color: var(--primary-icon);"><path clip-rule="evenodd" d="M18 8c0-.6-.4-1-1-1h-6a2 2 0 00-2 2v18c0 1.1.9 2 2 2h14a2 2 0 002-2V17c0-.6-.4-1-1-1h-4a4 4 0 01-4-4V8zm-6 7c0-.6.4-1 1-1h2a1 1 0 110 2h-2a1 1 0 01-1-1zm1 3.5a1 1 0 100 2h10a1 1 0 100-2H13zm0 4.5a1 1 0 100 2h10a1 1 0 100-2H13z" fill-rule="evenodd"></path><path d="M22 14h4a1 1 0 00.7-1.7l-5-5A1 1 0 0020 8v4c0 1.1.9 2 2 2z"></path></svg>
                      </div>
                      <div style="width: 100%; flex: 1;">
                        <div class="file-name">{{ file.fileName }}</div>
                        <div class="file-size">{{formatFileSize(file.fileSize)}} <span class="mx-2">&bull;</span> {{getTailFile(file.fileName)}}</div>
                      </div>
                    </div>
                  </div>
                  <div class="time">{{ msg.createTime | date:'HH:mm dd/MM/yyyy' }}</div>
                </div>
              </div>
            </ng-container>
            <ng-template #noMessage>
              <div style="margin: auto;">
                {{ 'negotiate_contract.chat.no_message' | translate }}
              </div>
            </ng-template>
          </div>
        </div>
      </mat-expansion-panel> 
        <mat-expansion-panel *ngIf="createContractType === 1 || (createContractType === 0 && document.mainContractAttachments?.length > 0 && !!document?.mainContractAttachments[activeFile]?.source && document?.mainContractAttachments[activeFile]?.source == 'FILE')" [expanded]="true" class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title class panel-title">
              {{ "enterprise_contract.sign_tab_title" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div>
            <mat-form-field class="w-100">
              <mat-label>{{ "file_sign" | translate }}
              </mat-label>
              <mat-select (selectionChange)="changeFileAddSign($event,'selectFileSign')"
                [(ngModel)]="selectedFileSign">
                <mat-option *ngFor="let file of fileUploads;let i = index" [value]="i">
                  {{ file.name }}
                </mat-option>
              </mat-select>
            </mat-form-field>
          </div>

          <nz-table #expandTable nzTableLayout="fixed" [nzFrontPagination]="false" [nzShowPagination]="false" class="ant-table-no-placeholder-border-bottom table-user-sign" nzBordered >
            <thead>
              <tr>
                <th class="text-center" nzWidth="10%">
                  {{ "enterprise_contract.panel_document.table_users.header.order_sign" | translate }}
                </th>
                <th class="text-center" nzWidth="45%">
                  {{ "enterprise_contract.panel_document.table_users.header.name" | translate }}
                </th>
                <th class="text-center" nzWidth="20%">
                  {{ "enterprise_contract.panel_document.table_users.header.role" | translate }}
                </th>
<!--                  <th class="text-center" nzWidth="5%">-->
<!--                    {{ "enterprise_contract.panel_document.table_users.header.change_size_and_position" | translate }}-->
<!--                  </th>-->

                <th class="text-center" nzWidth="25%">
                  {{ "enterprise_contract.panel_document.table_users.header.action" | translate }}
                </th>
              </tr>
            </thead>
            <tbody>
              <!-- nguoi dung phe duyet ben lap -->
              <ng-container *ngFor="let data of listData; let j = index">
              <tr *ngIf="listData.length">
                <td class="text-left" style="    background-color: #FFEDF1;
  color: black;
  font-weight: bold;">{{ data.order }}</td>
                <td colspan="4" style="    background-color: #FFEDF1;
  color: black;
  font-weight: bold;">
                  {{ data.name }}
                </td>
              </tr>
              <ng-container *ngFor="let ele of data.customerApproves; let i = index">
                <tr *ngIf="ele && (ele.isCreatedSide || (ele.image && ele.CTS) || (data.customerApproves.length == i +1 ) || ele.customerType)">
                  <td class="text-right"  *ngIf="data.customerApproves.length != i+1">{{ orderAcy(data.customerApproves,ele.userId) }}</td>
<!--                    <td class="text-right"  *ngIf="data.customerApproves.length != i+1">1</td>-->
                  <td class="text-right"  *ngIf="data.customerApproves.length == i+1">{{ orderAcy(data.customerApproves,ele.customerId?ele.customerId : ele.userId) }}</td>
                  <td class=" word-break">
                    {{ ele.name ? ele.name : ele.userName }}
                  </td>
                  <td  class="text-center" *ngIf="data.customerApproves.length != i+1">{{'enterprise_contract.buttons.approve' | translate }}</td>
                  <td  class="text-center" *ngIf="data.customerApproves.length == i+1">{{'enterprise_contract.buttons.sign' | translate }}</td>
<!--                    <td class="text-center">-->
<!--                      <mat-checkbox [ngModel]="ele?.resize" (ngModelChange)="ele.resize = $event" (click)="toggleResize(ele.resize)"  [ngModelOptions]="{standalone: true}" color="primary"></mat-checkbox>-->
<!--                    </td>-->

                  <td class="text-center">
<!--                      <button color="primary" mat-icon-button (click)="ele.resize = !ele.resize" class="mr-1"-->
                    <button color="primary" mat-icon-button (click)="onClickResize(j,i)" class="mr-1"
                            type="button">
                      <span *ngIf="ele.resize">
                        <img src="assets/images/drag_pan.svg"
                             matTooltip="{{ 'enterprise_contract.tooltips.off_change_size_and_position' | translate }}"
                             style="width: 22px; height: 22px;margin-bottom: 3px">
                      </span>
                      <span *ngIf="!ele.resize">
                        <img src="assets/images/drag_pan-1.svg"
                             matTooltip="{{ 'enterprise_contract.tooltips.on_change_size_and_position' | translate }}"
                             style="width: 22px; height: 22px;margin-bottom: 3px">
                      </span>
                    </button>
                    <button (click)="addSign(ele)" color="primary" mat-icon-button
                      type="button">
                      <mat-icon class="mr-0" matTooltip="{{
                        'enterprise_contract.tooltips.add_sign' | translate
                      }}">add_circle
                      </mat-icon>
                    </button>
                  </td>
                </tr>
                <ng-container *ngFor="let sign of listSign; let id = index">
                  <tr *ngIf="(ele && sign && sign.userId == ele.userId) && checkHaveSign(ele, sign)">
                    <td></td>
                    <td colspan="2"> {{ "signature_number" | translate }} {{sign.row_number}} (trang {{sign.pageIndex}})</td>
<!--                      <td class="text-center">{{sign.pageIndex}}</td>-->
                    <td class="text-center">
                      <button (click)="goToPage(ele.enterpriseId, ele.userId, sign,(ele.customerId || null))"
                        color="primary" mat-icon-button type="button">
                        <mat-icon class="mr-0" matTooltip="{{
                          'enterprise_contract.tooltips.go_to_sign' | translate
                        }}">double_arrow
                        </mat-icon>
                      </button>
                      <!-- <button (click)="deleteSign(data.enterpriseId, data.userId, sign.idNumber)" *ngIf="checkHaveSign(data, sign.idNumber)" -->
                      <button (click)="deleteSign(ele.enterpriseId, ele.userId, (sign.contractSignId || sign.idNumber) ,(ele.customerId || null))"
                        color="primary" mat-icon-button type="button">
                        <mat-icon class="mr-0" matTooltip="{{
                          'enterprise_contract.tooltips.delete_sign' | translate
                        }}">close
                        </mat-icon>
                      </button>
                    </td>
                  </tr>
                </ng-container>
              </ng-container>
              </ng-container>
              <!-- nguoi dung ky duyet ben lap -->
<!--                <tr *ngIf="listDataSign.enterprise.length">-->
<!--                  <td colspan="5">-->
<!--                    {{ "enterprise_contract.sign_table.create_side" | translate }}-->
<!--                  </td>-->
<!--                </tr>-->
<!--                <ng-container *ngFor="let data of listDataSign.enterprise; let i = index">-->
<!--                  <tr>-->
<!--                    <td class="text-center">{{ i + 1 }}</td>-->
<!--                    <td>-->
<!--                      {{ data.name }}-->
<!--                    </td>-->
<!--                    <td class="text-center">-->
<!--                      <mat-checkbox [ngModel]="data?.signConfig?.resize" (ngModelChange)="data.signConfig.resize = $event" [ngModelOptions]="{standalone: true}" color="primary"></mat-checkbox>-->
<!--                    </td>-->
<!--                    <td></td>-->
<!--                    <td class="text-center">-->
<!--                      <button (click)="addSign(data)" color="primary" mat-icon-button-->
<!--                        type="button">-->
<!--                        <mat-icon class="mr-0" matTooltip="{{-->
<!--                          'enterprise_contract.tooltips.add_sign' | translate-->
<!--                        }}">add_circle-->
<!--                        </mat-icon>-->
<!--                      </button>-->
<!--                    </td>-->
<!--                  </tr>-->
<!--                  <ng-container *ngFor="let sign of listSign; let id = index">-->
<!--                    <tr *ngIf="sign.userId == data.userId && checkHaveSign(data, sign)">-->
<!--                      <td></td>-->
<!--                      <td colspan="2"> {{ "signature_number" | translate }} {{sign.row_number}}</td>-->
<!--                      <td class="text-center">{{sign.pageIndex}}</td>-->
<!--                      <td class="text-center">-->
<!--                        <button (click)="goToPage(data.enterpriseId, data.userId, sign)"-->
<!--                          color="primary" mat-icon-button type="button">-->
<!--                          <mat-icon class="mr-0" matTooltip="{{-->
<!--                            'enterprise_contract.tooltips.go_to_sign' | translate-->
<!--                          }}">double_arrow-->
<!--                          </mat-icon>-->
<!--                        </button>-->
<!--                        <button (click)="deleteSign(data.enterpriseId, data.userId, (sign.contractSignId || sign.idNumber))"-->
<!--                          color="primary" mat-icon-button type="button">-->
<!--                          <mat-icon class="mr-0" matTooltip="{{-->
<!--                            'enterprise_contract.tooltips.delete_sign' | translate-->
<!--                          }}">close-->
<!--                          </mat-icon>-->
<!--                        </button>-->
<!--                      </td>-->
<!--                    </tr>-->
<!--                  </ng-container>-->
<!--                </ng-container>-->
              <!-- khach hang -->
<!--                <tr *ngIf="listDataSign.customer.length">-->
<!--                  <td colspan="5">-->
<!--                    {{ "enterprise_contract.sign_table.customers" | translate }}-->
<!--                  </td>-->
<!--                </tr>-->
<!--                <ng-container *ngFor="let data of listDataSign.customer; let i = index">-->
<!--                  <tr>-->
<!--                    <td class="text-center">{{ i + 1 }}</td>-->
<!--                    <td>-->
<!--                      {{ data.name }}-->
<!--                    </td>-->
<!--                    <td class="text-center">-->
<!--                      <mat-checkbox [ngModel]="data?.signConfig?.resize" (ngModelChange)="data.signConfig.resize = $event" [ngModelOptions]="{standalone: true}" color="primary"></mat-checkbox>-->
<!--                    </td>-->
<!--                    <td></td>-->
<!--                    <td class="text-center">-->
<!--                      <button (click)="addSign(data)" color="primary" mat-icon-button-->
<!--                        type="button">-->
<!--                        <mat-icon class="mr-0" matTooltip="{{-->
<!--                          'enterprise_contract.tooltips.add_sign' | translate-->
<!--                        }}">add_circle-->
<!--                        </mat-icon>-->
<!--                      </button>-->
<!--                    </td>-->
<!--                  </tr>-->
<!--                  <ng-container *ngFor="let sign of listSign; let id = index">-->
<!--                    <tr *ngIf="sign.customerId == data.customerId && checkHaveSign(data, sign)">-->
<!--                      <td></td>-->
<!--                      <td colspan="2"> {{ "signature_number" | translate }} {{sign.row_number}}</td>-->
<!--                      <td class="text-center">{{sign.pageIndex}}</td>-->
<!--                      <td class="text-center">-->
<!--                        <button (click)="goToPage(data.enterpriseId || data.customerId, data.userId, sign)"-->
<!--                          color="primary" mat-icon-button type="button">-->
<!--                          <mat-icon class="mr-0" matTooltip="{{-->
<!--                            'enterprise_contract.tooltips.go_to_sign' | translate-->
<!--                          }}">double_arrow-->
<!--                          </mat-icon>-->
<!--                        </button>-->
<!--                        <button (click)="deleteSign(data.enterpriseId || data.customerId, data.userId, (sign.contractSignId || sign.idNumber))"-->
<!--                          color="primary" mat-icon-button type="button">-->
<!--                          <mat-icon class="mr-0" matTooltip="{{-->
<!--                            'enterprise_contract.tooltips.delete_sign' | translate-->
<!--                          }}">close-->
<!--                          </mat-icon>-->
<!--                        </button>-->
<!--                      </td>-->
<!--                    </tr>-->
<!--                  </ng-container>-->
<!--                </ng-container>-->
            </tbody>
          </nz-table>
        </mat-expansion-panel>

        <!-- cấu hình mã hợp đồng -->
        <mat-expansion-panel *ngIf="createContractType === 1"  [expanded]="true" class="mat-elevation-z0">
          <mat-expansion-panel-header>
            <mat-panel-title class="mat-panel-title class panel-title">
              {{ "enterprise_contract.contract_code_configuration" | translate }}
            </mat-panel-title>
          </mat-expansion-panel-header>
          <div class="mb-2">

            <div>
              <span *ngIf="isOnAutoNumber && (!isUpdate || (refreshContractCode && isUpdate))">{{
                "headertable.contract_code_format" | translate }}: </span>
              <span *ngIf="isOnAutoNumber && (!isUpdate || (refreshContractCode && isUpdate))"
                style="font-weight: bold; word-break: break-all;">{{configAutoNumber}}</span>
            </div>

            <div>
              <span *ngIf="!document.code && !isOnAutoNumber" style="font-weight: bold;" class="text-primary">{{
                "headertable.doc_code_required" | translate }}: </span>
              <span *ngIf="!isOnAutoNumber && !document.code"
                style="font-style: italic;" class="text-primary">{{'validation.document_type_code' | translate}}</span>
            </div>

            <div style="font-weight: bold;">
              <span
                *ngIf="(!refreshContractCode && isOnAutoNumber && isUpdate) ||(!isOnAutoNumber && document.code)">{{'system_request.contractCode'
                | translate}}: </span>
              <span *ngIf="(!refreshContractCode && isOnAutoNumber && isUpdate)"
                style="font-weight: bold; word-break: break-all;">{{configAutoNumber}}</span>
              <span *ngIf="!isOnAutoNumber && document.code"
                style="font-weight: bold; word-break: break-all;">{{document.code}}</span>
            </div>


          </div>
          <div *ngIf="isOnAutoNumber && (!isUpdate || (refreshContractCode && isUpdate))"><span
              style="font-weight: bold;">{{'title.note' | translate}}</span> <span style="font-style: italic;">
              {{'headertable.contract_code_change_create' | translate}}</span></div>
          <div class="row" style="flex-wrap: nowrap; justify-content: space-around;padding-top: 20px;">
            <div class="col-8">
              <mat-form-field class="w-100">
                <mat-label>{{'enterprise_document_template_add_pop.lbl_choose_file_add_location' | translate}}
                </mat-label>
                <mat-select (selectionChange)="changeFileAddContractCode($event,'selectFile')"
                  [(ngModel)]="selectedFile">
                  <mat-option *ngFor="let file of fileUploads;let i = index" [value]="i">
                    {{ file.name }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
            <div class="col-2" style="width: 20%; padding-right: 20px;">
              <mat-form-field class="w-100">
                <mat-label style="overflow: inherit;">{{'enterprise_document_template_add_pop.page_number' |
                  translate}}
                </mat-label>
                  <input [disabled]="isCheckFile" min="1" [max]="totalPage" matInput type="number" [(ngModel)]="selectedNumberPage" (input)="validateInput($event)"
                  (blur)="limitValue()" oninput="validity.valid"
                  onkeypress="return (event.charCode == 0 || event.charCode == 13) ? null : event.charCode >= 48 && event.charCode <= 57">
              </mat-form-field>
            </div>
            <div class="col-2">
              <button [disabled]="selectedNumberPage == null || selectedNumberPage == 0" mat-stroked-button color="primary"
                (click)="addSignatureToTable()" [ngClass]="{'btn-not-allow': !(selectedFile || selectedNumberPage)}"
                style="min-width: unset !important ; margin-top: 6px;">
                <mat-icon class="mr-0">add_circle_outline</mat-icon>{{'enterprise_document_template_add_pop.add' |
                translate}}
              </button>
            </div>
          </div>
          <div class="w-100 pb-2" style="font-style: italic; transform: translateY(-10px) !important;">
            <span>{{'validation.choose_file_add_location' | translate}}</span>
          </div>
          <nz-table #partyRowTable nzBordered [nzShowPagination]="false" [nzFrontPagination]="false"
            class="ant-table-no-placeholder-border-bottom no-ant-table-placeholder">
            <thead>
              <tr>
                <th class="text-center" style="width:20px">
                  {{ "enterprise_contract.table_headers.location"| translate }}
                </th>
                <th class="text-center" style="width:20px">
                  {{ "enterprise_contract.table_headers.font"| translate}}
                </th>
                <th class="text-center" style="width:20px">
                  {{ "enterprise_contract.table_headers.size"| translate }}
                </th>
                <th class="text-center" style="width:20px">
                  {{ "enterprise_contract.table_headers.format"| translate }}
                </th>
                <th class="text-center" style="width:20px">
                  {{ "enterprise_contract.table_headers.page"| translate }}
                </th>
                <th style="width:20px"></th>
              </tr>
            </thead>
            <tbody *ngIf="listSignatureTable.length">
              <ng-container *ngFor="let item2 of listSignatureHeadRows;">
                <tr *ngIf="listSignatureHeadRows.length">
                  <td></td>
                  <td class="text-center">
                    <span style="font-weight: bold;">{{item2}}</span>
                  </td>
                  <td></td>
                  <td></td>
                  <td></td>
                  <td></td>
                </tr>
                <ng-container *ngFor="let item of listSignatureTable; let i = index">
                  <tr *ngIf="item2 === (item.fileName ? item.fileName : getDecodeUri(item.fileId))">
                    <td class="text-center">{{countIndexTable(item.id, item2)}}</td>
                    <td class="text-center">
                      <mat-form-field style="width:145px">
                        <mat-select (selectionChange)="onChangeFont($event,item)" [(ngModel)]="item.fontFamily"
                          required>
                          <mat-option *ngFor="let item of listFont;let i = index" [style.fontFamily]='item.fontFamily'
                            [value]="item.value">
                            <span [style.fontFamily]='item.value'>{{ item.name }}</span>
                          </mat-option>
                        </mat-select>
                      </mat-form-field>
                    </td>
                    <td>
                      <mat-form-field style="width:35px">
                        <input matInput type="number" min="10" max="30" (keyup.enter)="onKeyChangeFontSize()"
                          (blur)="onKeyChangeFontSize()" [(ngModel)]="item.fontSize">
                      </mat-form-field>
                    </td>

                    <td class="text-center">
                      <div class="d-flex align-item-center justify-content-center">
                        <mat-button-toggle-group [(ngModel)]="item.fontStyle"
                          (change)="chooseFormatFont($event.value, item)" name="ingredients" aria-label="Ingredients"
                          multiple>
                          <mat-button-toggle value="bold"><mat-icon> format_bold</mat-icon></mat-button-toggle>
                          <mat-button-toggle value="italic"><mat-icon> format_italic</mat-icon></mat-button-toggle>
                          <mat-button-toggle value="underline"><mat-icon>
                              format_underlined</mat-icon></mat-button-toggle>
                        </mat-button-toggle-group>
                      </div>
                    </td>
                    <td class="text-center" style="width: 20px;">{{item.page}}</td>
                    <td class="text-center">
                      <div class="d-flex align-item-center justify-content-center">
                        <button color="primary" (click)="goToPageSignature(item)" mat-icon-button type="button">
                          <mat-icon class="mr-0" matTooltip="{{
                'enterprise_contract.tooltips.go_to_sign_contract_code' | translate
              }}">double_arrow
                          </mat-icon>
                        </button>
                        <button color="primary" (click)="deleteSignature(item.id)" mat-icon-button type="button">
                          <mat-icon class="mr-0" matTooltip="{{
                'enterprise_contract.tooltips.delete_sign_contract_code' | translate
              }}">close
                          </mat-icon>
                        </button>
                      </div>
                    </td>
                  </tr>
                </ng-container>

              </ng-container>
            </tbody>
            <!--        <tbody *ngIf="listSignatureTable.length">-->
            <!--            <tr *ngFor="let item of listSignatureTable; let i = index">-->
            <!--              <td></td>-->
            <!--              <td class="text-center">-->
            <!--                <span style="font-weight: bold;">{{item.fileName}}</span>-->
            <!--              </td>-->
            <!--              <td></td>-->
            <!--              <td></td>-->
            <!--              <td></td>-->
            <!--              <td></td>-->
            <!--            </tr>-->
            <!--            <tr *ngFor="let item of listSignatureTable; let i = index">-->
            <!--              <td class="text-center">{{i + 1}}</td>-->
            <!--              <td class="text-center">-->
            <!--                <mat-form-field>-->
            <!--                  <mat-select (selectionChange)="onChangeFont($event,item)" [(ngModel)]="item.fontFamily" required>-->
            <!--                    <mat-option *ngFor="let item of listFont;let i = index" [style.fontFamily] = 'item.fontFamily'-->
            <!--                    [value]="item.value">-->
            <!--                    <span [style.fontFamily] = 'item.value'>{{ item.name }}</span>-->
            <!--                    </mat-option>-->
            <!--                  </mat-select>-->
            <!--                </mat-form-field>-->
            <!--              </td>-->
            <!--              <td>-->
            <!--                <mat-form-field class="w-50">-->
            <!--                  <input matInput type="number" min="10" max="16" (ngModelChange)="onChangeFontSize($event, item)" (keyup)="onKeyChangeFontSize($event, item)" [(ngModel)]="item.fontSize">-->
            <!--                </mat-form-field>-->
            <!--              </td>-->
            <!--              -->
            <!--              <td class="text-center">-->
            <!--                <div class="d-flex align-item-center justify-content-center">-->
            <!--                  <mat-button-toggle-group [(ngModel)]="item.fontStyle" (change)="chooseFormatFont($event.value, item)" name="ingredients" aria-label="Ingredients" multiple>-->
            <!--                    <mat-button-toggle value="bold"><mat-icon> format_bold</mat-icon></mat-button-toggle>-->
            <!--                    <mat-button-toggle value="italic"><mat-icon> format_italic</mat-icon></mat-button-toggle>-->
            <!--                    <mat-button-toggle value="underline"><mat-icon> format_underlined</mat-icon></mat-button-toggle>-->
            <!--                  </mat-button-toggle-group>-->
            <!--                </div>-->
            <!--              </td>-->
            <!--              <td class="text-center">{{item.page}}</td>-->
            <!--              <td class="text-center"> -->
            <!--                <div class="d-flex align-item-center justify-content-center">-->
            <!--                  <button color="primary" (click)="goToPageSignature(item)" -->
            <!--                      mat-icon-button type="button">-->
            <!--                      <mat-icon class="mr-0" matTooltip="{{-->
            <!--                        'enterprise_contract.tooltips.go_to_sign_contract_code' | translate-->
            <!--                      }}">double_arrow-->
            <!--                      </mat-icon>-->
            <!--                </button>-->
            <!--                <button color="primary" (click)="deleteSignature(item.id)" -->
            <!--                      mat-icon-button type="button">-->
            <!--                      <mat-icon class="mr-0" matTooltip="{{-->
            <!--                        'enterprise_contract.tooltips.delete_sign_contract_code' | translate-->
            <!--                      }}">close-->
            <!--                      </mat-icon>-->
            <!--                </button>-->
            <!--                </div>-->
            <!--              </td>-->
            <!--            </tr>-->
            <!--        </tbody>-->
          </nz-table>
        </mat-expansion-panel>
        <!-- end cấu hình mã hợp đồng -->

        <app-footnote #footNote [hidden]="createContractType === 1 || (createContractType === 0 && document.mainContractAttachments?.length > 0 && !!document?.mainContractAttachments[activeFile]?.source && document.mainContractAttachments[activeFile]?.source == 'FILE')"></app-footnote>
      </div>
    </div>
  </div>


  <!-- View file -->
  <div [ngClass]="{
      'col-lg-7 pl-0': tabMode !== 'hide',
      'col-lg-12': tabMode === 'hide'
    }" class="col-lg-7 col-md-12 col-sm-12" style="padding-right: 0.75rem">
    <div [ngStyle]="{
        'background-color':
          createContractType === 1 && fileUploads.length ? '#a6a6a6' : '#fff'
      }" class="text-left mat-elevation-z0 d-flex justify-content-between align-items-center">
      <div [ngStyle]="{
          'border-bottom-right-radius': activeFile === 0 ? '5px' : '0'
        }" class="pl-3 py-2 box-left">
        <button (click)="tabMode = 'hide'" *ngIf="tabMode !== 'hide'" [matTooltip]="
            'enterprise_contract.tooltips.btn_expand_more' | translate
          " class="mr-2 custom-button-icon" color="primary" mat-stroked-button type="button">
          <mat-icon class="mr-0" style="vertical-align: middle; width: auto; height: auto">fullscreen</mat-icon>
        </button>
        <button (click)="tabMode = 'info'" *ngIf="tabMode === 'hide'"
          [matTooltip]="'enterprise_contract.tooltips.info_tab' | translate" class="mr-2 custom-button-icon"
          color="primary" mat-stroked-button type="button">
          <mat-icon class="mr-0" style="vertical-align: middle; width: auto; height: auto">info</mat-icon>
        </button>
        <!-- <button class="mr-2 custom-button-icon" mat-stroked-button color="primary" (click)="openTabSign()"
        *ngIf="tabMode === 'hide'" type="button" [matTooltip]="'enterprise_contract.tooltips.sign_tab' | translate">
          <mat-icon class="mr-0" style="vertical-align: middle; width: auto; height: auto">border_color</mat-icon>
        </button> -->
      </div>
      <div *ngIf="createContractType === 1 || createContractType == 0" [ngStyle]="{
          background: fileUploads.length
            ? 'linear-gradient(180deg, #fff 70%, #a6a6a6 30%)'
            : '#fff'
        }" class="tab-file">
        <div style="width: 100%; position: relative; height: 52px;">
          <div class="d-flex box-tab" cdkDropList cdkDropListOrientation="horizontal" (cdkDropListDropped)="drop($event)"
            style="position: absolute; width: 100%; top: 0.5rem; left: 0; height: calc(52px - 0.5rem);">
            <div (click)="changeFile(file.path, i)" cdkDrag
              *ngFor="let file of document.mainContractAttachments; let i = index" [class.active]="i === activeFile"
              [class.border-right]="i !== fileUploads.length - 1 && i !== activeFile && i !== activeFile - 1"
              [class.left]="i === activeFile - 1" [class.right]="i === activeFile + 1" [matTooltip]="file.fileName + ' (' + (file.fileSize/1024/1024).toFixed(2) + 'mb)'"
              class="pl-2 py-2 tab d-flex">
              <div class="name">
                {{ file.fileName }}
              </div>
              <a (click)="removeFile(i)" *ngIf="createContractType == 1 || (createContractType == 0 && (file?.source && file?.source == 'FILE'))"><span class="material-icons"> close </span></a>
            </div>
          </div>
        </div>
      </div>
      <div [ngStyle]="{
          'border-bottom-left-radius':
            activeFile === fileUploads.length - 1 ? '5px' : '0'
        }" class="d-flex pr-3 py-2 box-right">
        <!-- Chọn tệp từ máy -->
        <div class="ml-2">
          <button #btnUpload (click)="chooseFile()" *ngIf="isShowMatRaised !== 'local'" appTrackEvent="w.btn.lap_hd_mau.chon_tep_tu_may"
            [disabled]="warningContractQuantity" [matTooltip]="'button.choose_a_file' | translate"
            class="mr-2 mat-stroked-button-create-document custom-button-icon" color="primary" id="btnUpload"
            mat-stroked-button type="button">
            <mat-icon class="mr-0">cloud_upload</mat-icon>
          </button>
          <button #btnUpload (click)="chooseFile()" *ngIf="isShowMatRaised === 'local'" appTrackEvent="w.btn.lap_hd_file.chon_tep_tu_may"
            [disabled]="warningContractQuantity" [matTooltip]="'button.choose_a_file' | translate"
            class="mr-2 mat-stroked-button-create-document custom-button-icon" color="primary" id="btnUpload"
            mat-raised-button type="button">
            <mat-icon class="mr-0">cloud_upload</mat-icon>
          </button>
          <input #inputUpload (change)="onSelectedUpload($event)" accept="application/pdf"
            class="form-control-file vt-input-form d-none mat-stroked-button-create-document" id="file" multiple
            name="file" type="file" />
        </div>

        <!-- Chọn từ mẫu (Tạm thời ẩn chức năng này) -->
        <div>
          <button #btnForm (click)="onSelectedForm()" *ngIf="isShowMatRaised !== 'server' && document.formType !== 'CONTRACT_TERMINATION'" appTrackEvent="w.btn.lap_hd_file.chon_tu_mau_khac"
            [disabled]="warningContractQuantity" [matTooltip]="'button.document_form_another' | translate"
            class="mat-stroked-button-create-document custom-button-icon" color="primary" id="btnSelectTemplate"
            mat-stroked-button type="button">
            <mat-icon class="mr-0">book</mat-icon>
          </button>
          <button #btnForm (click)="onSelectedForm()" *ngIf="isShowMatRaised === 'server' && document.formType !== 'CONTRACT_TERMINATION'" appTrackEvent="w.btn.lap_hd_mau.chon_tu_mau_khac"
            [disabled]="warningContractQuantity" [matTooltip]="'button.document_form_another' | translate"
            class="mat-stroked-button-create-document custom-button-icon" color="primary" id="btnSelectTemplate"
            mat-raised-button type="button">
            <mat-icon class="mr-0">book</mat-icon>
          </button>
        </div>
      </div>
    </div>

    <!-- <hr style="margin: 0" /> -->
    <div #navigation class="document" id="pdfContainer" style="height: calc(85vh - 140px)">
      <ng-container *ngIf="pdfSrc && !isHide; else notUpload">
        <ng-container *ngIf="pdfSrc && !isShowReferencePdf && createContractType === 0  && (document.mainContractAttachments?.length > activeFile || document.mainContractAttachments?.length == 0 )">
          <ng-container *ngIf="(document.mainContractAttachments?.length > activeFile && document?.mainContractAttachments[activeFile]?.source == 'FORM' || !document.mainContractAttachments[activeFile]?.source) || document.mainContractAttachments?.length == 0">
            <ngx-extended-pdf-viewer class="pdf-viewer" [src]="pdfSrc" useBrowserLocale="true"
            [showDownloadButton]="false" [showRotateButton]="false" [showOpenFileButton]="false"
            [showBookmarkButton]="false" [showPropertiesButton]="false" [showUnverifiedSignatures]="true"
            [sidebarVisible]="true" [enablePrint]="false" [theme]="'dark'" [language]="language"
            height="calc(85vh - 140px)" style="display: block" [textLayer]="true"
            (textLayerRendered)="textLayerFormRendered($event)" [handTool]="false" [(zoom)]="zoomLevel"
            [httpHeaders]="authorization"></ngx-extended-pdf-viewer>
          </ng-container>
        </ng-container>
        <ng-container *ngIf="pdfSrc && !isShowReferencePdf && (createContractType === 1 || (createContractType === 0 && document.mainContractAttachments?.length > activeFile && document?.mainContractAttachments[activeFile]?.source == 'FILE'))">
          <ngx-extended-pdf-viewer (currentZoomFactor)="onChangeZoom($event)" (pagesLoaded)="onPagesLoaded($event)"
            (textLayerRendered)="textLayerRendered($event)" [(page)]="pageIndex" [enablePrint]="false"
            [handTool]="false" [language]="language" [showBookmarkButton]="false" [showDownloadButton]="false"
            [showOpenFileButton]="false" [showPropertiesButton]="true" [showRotateButton]="false"
            [showSecondaryToolbarButton]="false" [showUnverifiedSignatures]="true" [sidebarVisible]="true"
            [src]="pdfSrc" [textLayer]="true" [theme]="'dark'" [zoomLevels]="[0.5, 1, 1.25, 1.5, 2, 3, 4]"
            class="pdf-viewer" height="calc(85vh - 140px)" style="display: block" useBrowserLocale="true"
            [httpHeaders]="authorization">
          </ngx-extended-pdf-viewer>
        </ng-container>
      </ng-container>

      <!-- No file -->
      <div style="display: flex; justify-content: center; align-items: center">
        <ng-template #notUpload>
          <div *ngIf="!pdfSrc && !isHide" class="container">
            <div class="drd-container">
              <input #inputUpload (change)="onSelectedUpload($event)" accept="application/pdf"
                class="form-control-file vt-input-form d-none" id="file" multiple name="file" style="cursor: pointer"
                type="file" />
              <br />
              <button #btnUpload1 (click)="inputUpload.click()" [disabled]="warningContractQuantity"
                class="mr-2 mat-stroked-button-create-document" color="primary" id="btnUpload1" mat-stroked-button
                type="button">
                <mat-icon class="mr-0">cloud_upload</mat-icon>
                {{ "button.choose_a_file" | translate }}
              </button>

              <h5 style="margin-top: 2em">
                ({{ maxSizeError }})
              </h5>
              <br /><br />
            </div>
          </div>
        </ng-template>
      </div>
    </div>
    <hr style="margin: 0" />
  </div>
</div>
</div>
